import React, { useContext, useEffect, useState, useRef} from "react";
import PropTypes from "prop-types";

import { Form, Col, CustomContainer } from "../../atoms/DependencyHelper";
import formStyles from "../../atoms/newLineForms/NewLineForms.module.scss";
import {
  africaCountryCode,
  hideSpinner,
  showSpinner,
} from "../../../utils/helperServices";
import { useDispatch, useSelector } from "react-redux";
import {
  setNumberToTranfer,
  setNumberTranferType,
  setNumberTransferDetails,
} from "../../../Redux/actions/checkoutAction";
import errorMessages from "../../../config/errorMessages";
import styles from "./numberTransferTypes.module.scss";
import { NumberTransferTypes } from "../../../config/constants";
import labels from "../../../config/labels";
import UpgradeComponent from "../upgradeModal/UpgradeModal";
import microServices from "../../../utils/microServices";
import * as Analytics from "../../../services/analyticsUtag";
import GeneralError from "./GeneralError";
import NumberTransferCheckboxes from "./NumberTransferCheckboxes";
import { NumberTransferCBU } from "../../organisms/NumberTransfer/NumberTransfer";
import { journeyType } from "../../../context/checkout-journey-context";

const NumberTransferNumber = ({ setShowSnackBar, navigate, currentJourneyType, customerStatus }) => {
  const [error, setError] = useState("");
  const { multicartFlag } = useContext(NumberTransferCBU);
  const [otpResent, setOtpResent] = useState(false);
  const dispatch = useDispatch();
  const [attempts, setAttempts] = useState(1);
  const [generalError, showGeneralError] = useState(false);
  const [otp, setOtp] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [checkboxes, setCheckBoxes] = useState({
    prepaid: false,
    new: false,
    forfeit: false,
  });
  const prevCheckboxRef = useRef();
  const keepNumberErrorScenario = Object.freeze({
    "Legacy_number": "Legacy_number",
    "Existing_port_in_request": "Existing_port_in_request",
    "Port_in_request_in_past_60_days": "Port_in_request_in_past_60_days",
    "Vodacom_contract_number": "Vodacom_contract_number",
    "Number_not_validated": "Number_not_validated"
  });
  const sendAnalitycsLink = (additionalInfo) => {
    Analytics.link({
      ...Analytics.getUtagData([
        "page_name",
        "page_channel",
        "page_master_tab",
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
      link_type: "o",
      ...additionalInfo,
    });
  };
  const validateNumber = (number) => {
    const minlenght = africaCountryCode(number) ? 11 : 10;
    if (!/^[0-9]*$/.test(number)) {
      return errorMessages.checkoutAuthentication.cellNumber.onlyNumber;
    }
    if (!/^0|27[0-9]*$/.test(number)) {
      return errorMessages.checkoutAuthentication.cellNumber.startWith;
    }
    if (number.length < minlenght) {
      return errorMessages.checkoutAuthentication.errors.auth.cellNumber;
    }
    return "";
  };

  const authDetails = useSelector(
    ({ checkoutDetails }) => checkoutDetails.authDetails
  );

  const onChange = (event) => {
    dispatch(setNumberToTranfer(event.target.value));
    const valError = validateNumber(event.target.value);
    if (!valError) {
      sendAnalitycsLink({
        page_form_event: "start",
        page_form_name:
          `checkout: number transfer: ${customerStatus}: vodacom terms and conditions`,
      });
    }
    setError(valError);
    setAttempts(1);
  };

  const buttonDisabled = () => {
    const numberValid = !validateNumber(value);
    const termsAccepted = Object.values(checkboxes).every((term) => term);
    return !numberValid || !termsAccepted;
  };

  const sendOtp = (number) => {
    showSpinner();
    setShowModal(false);
    microServices
      .post(
        "api",
        "oneTimePinv2",
        {
          destinations: [
            {
              address: number,
              message: "otp-default-sms-message",
              type: "SMS",
            },
          ],
        },
        null,
        false,
        [number]
      )
      .then((responseData) => {
        if (responseData.fail) {
          setShowSnackBar({ visible: false });
          showGeneralError(true);
          setShowModal(false);
          return;
        }
        Analytics.view({
          page_event: "view",
          multicart_flag: multicartFlag ? true : false,
          page_name: `checkout: number transfer: ${customerStatus}: enter otp`,
          ...Analytics.getUtagData([
            "page_channel",
            "page_master_tab",
            "visitor_login_status",
            "visitor_customer_id",
            "visitor_id_hash",
            "visitor_msisdn_hash",
            "visitor_subscription_type",
          ]),
        });
        setShowModal(true);
      })
      .catch(() => {
        setShowSnackBar({ visible: false });
        showGeneralError(true);
        setShowModal(false);
      })
      .finally(() => hideSpinner());
  };

  const onSubmit = () => {
    if (!buttonDisabled()) {
      sendAnalitycsLink({
        link_name: `checkout: number transfer: ${customerStatus}: next`,
        page_form_event: "success",
        page_form_name: `checkout: number transfer: ${customerStatus}: ${active} terms and conditions`,
      });

      if (currentJourneyType == journeyType.addLine && value !== authDetails.msisdn) {
        handleKeepNumberError(keepNumberErrorScenario.Number_not_validated);
        return;
      }
      
      sendOtp(value);
      return;
    }

    sendAnalitycsLink({
      link_name: `checkout: number transfer: ${customerStatus}: next`,
      page_form_event: "error",
      page_form_name: `checkout: number transfer: ${customerStatus}: ${active} terms and conditions`,
      page_errors: !Object.values(checkboxes).every((term) => term)
        ? "Terms are not accepted"
        : validateNumber(value),
    });
  };

  const validateOtp = (otpNum, phone) => {
    sendAnalitycsLink({
      link_name: `checkout: number transfer: ${customerStatus}: submit otp`,
      link_type: "o",
    });
    setShowSnackBar({
      visible: false,
    });
    microServices
      .get("api", "oneTimePinEligible", null, false, [phone, otpNum.join("")])
      .then((response) => {
        const currentAttempts = attempts + 1;
        setOtp(["", "", "", ""]);
        setAttempts(currentAttempts);
        setShowSnackBar({
          visible: false,
        });

        if (currentAttempts > 3) {
          showGeneralError(true);
          setShowModal(false);

          Analytics.view({
            page_event: "view",
            multicart_flag: multicartFlag ? true : false,
            page_name: `checkout: number transfer: ${customerStatus}: otp failed a third time`,
            ...Analytics.getUtagData([
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
              "visitor_subscription_type",
            ]),
          });
          return;
        }
        if (response.fail) {
          Analytics.view({
            page_event: "view",
            multicart_flag: multicartFlag ? true : false,
            page_name: `checkout: number transfer: ${customerStatus}: otp failed ${
              attempts === 1 ? "once" : "twice"
            }`,
            ...Analytics.getUtagData([
              "page_channel",
              "page_master_tab",
              "visitor_login_status",
              "visitor_customer_id",
              "visitor_id_hash",
              "visitor_msisdn_hash",
              "visitor_subscription_type",
            ]),
          });
          setShowSnackBar({
            visible: true,
            message: labels.upgrade[`lbl_invalid_otp_try_${attempts}`],
            className: styles["number-transfer-snack-bar"],
          });
          return;
        }

        setShowModal(false);

        showSpinner();
        microServices
          .get("api", "validatePhoneForPrepaidNumber", null, false, [phone])
          .then(async (data) => {
            let error = data?.response?.data?.result?.errors?.find((error) => error?.errorCode === "SRV-404") || data.error.status === 404;

            if (error) {
              // call port in request
              const portInData = await getPortInRequest(phone, authDetails);
              hideSpinner();
              if (!portInData) {
                // Number not validated
                handleKeepNumberError(keepNumberErrorScenario.Number_not_validated);
              } else {
                if (portInData?.result?.eligible) {
                  // success
                  dispatch(
                    setNumberTransferDetails({
                      success: true,
                      details: portInData
                    })
                  );
                }
                else if ([
                  "PORT-IN ACTIVATED",
                ].includes(portInData?.result?.status) && !portInData?.result?.eligible) {
                  // Vodacom Contract Number
                  handleKeepNumberError(keepNumberErrorScenario.Vodacom_contract_number);
                }
                else if ([
                  "PORT-IN PENDING",
                  "PORT-IN APPROVED"
                ].includes(portInData?.result?.status) && !portInData?.result?.eligible) {
                  // Request in past 60 days
                  handleKeepNumberError(keepNumberErrorScenario.Port_in_request_in_past_60_days);
                }
              }
            }
            else {
              if (data.response?.data?.result?.msisdnDetails) {
                hideSpinner();
                const { SUBSCRIBERTYPE, C3D, VSP } = data.response?.data?.result?.msisdnDetails;
  
                if (SUBSCRIBERTYPE === "PREPAID" &&
                    VSP === "true" &&
                    C3D === "false") {
                  // Legacy Number
                  handleKeepNumberError(keepNumberErrorScenario.Legacy_number);
                }
                else if (SUBSCRIBERTYPE === "CONTRACT" ||
                         SUBSCRIBERTYPE === "HYBRID") {
                  // Vodacom Contract Number
                  handleKeepNumberError(keepNumberErrorScenario.Vodacom_contract_number);
                } 
                else if (SUBSCRIBERTYPE === "PREPAID" &&
                         C3D === "true" &&
                         VSP === "true") {
                  dispatch(
                    setNumberTransferDetails({
                      success: true,
                      details: data.response?.data?.result?.msisdnDetails,
                    })
                  );
                }
              }
            }

            // probable error scenario: Inactive Number
            // instead of creating lead form, we are going to poped up the generic error screen
            if (data.response.status !== 200 && !error) {
              hideSpinner();
              showGeneralError(true);
              return;
            }
          })
          .catch(() => {
            hideSpinner();
            setOtp(["", "", "", ""]);
            showGeneralError(true);
          });
      })
      .catch(() => showGeneralError(true));
  };

  const handleKeepNumberError = (type) => {
    dispatch(
      setNumberTranferType(NumberTransferTypes.NEW_NUMBER)
    );

    switch (type) {
      case "Legacy_number":
        dispatch(
          setNumberTransferDetails({
            success: false,
            errorType: keepNumberErrorScenario.Legacy_number
          })
        );
        updateAnalyticsForError("legacy");
        break;

      case "Vodacom_contract_number":
        dispatch(
          setNumberTransferDetails({
            success: false,
            errorType: keepNumberErrorScenario.Vodacom_contract_number
          })
        );
        updateAnalyticsForError("postpaid number");
        break;

      case "Existing_port_in_request":
        dispatch(
          setNumberTransferDetails({
            success: false,
            errorType: keepNumberErrorScenario.Existing_port_in_request
          })
        );
        updateAnalyticsForError("port in request");
        break;

      case "Port_in_request_in_past_60_days":
        dispatch(
          setNumberTransferDetails({
            success: false,
            errorType: keepNumberErrorScenario.Port_in_request_in_past_60_days
          })
        );
        updateAnalyticsForError("60 days");
        break;

      case "Number_not_validated":
        dispatch(
          setNumberTransferDetails({
            success: false,
            errorType: keepNumberErrorScenario.Number_not_validated
          })
        );
        updateAnalyticsForError("Number not validated");
        break;
    
      default:
        break;
    }

    return;
  }

  const updateAnalyticsForError = (errorType) => {
    Analytics.view({
      page_event: "view",
      multicart_flag: multicartFlag ? true : false,
      page_name: `checkout: number transfer: ${errorType}`,
      ...Analytics.getUtagData([
        "page_channel",
        "page_master_tab",
        "visitor_login_status",
        "visitor_customer_id",
        "visitor_id_hash",
        "visitor_msisdn_hash",
        "visitor_subscription_type",
      ]),
    });
  }

  const getPortInRequest = async (phone, authDetails) => {
    const res = await microServices.get(
                  "api", 
                  "portInValidation", 
                  null, 
                  true, 
                  [
                    phone,
                    `${authDetails.idNumber}?activationType=Port-In`,
                  ]);
    const response = res.response?.data;
    return response;
  }

  useEffect(() => {
    prevCheckboxRef.current = checkboxes;
  });
  const prevCheckbox = prevCheckboxRef.current;

  useEffect(() => {
    let isPreviousSelected;
    if (prevCheckbox) {
      isPreviousSelected = Object.values(prevCheckbox).filter(item => item);
    }
    let count = 0;
    for (const key in checkboxes) {
      if (Object.hasOwnProperty.call(checkboxes, key)) {
        if (checkboxes[key] && isPreviousSelected?.length === 0) {
          count += 1;
        }
      }
    }

    if (count === 1) {
      sendAnalitycsLink({
        page_form_event: "start",
        page_form_name: `checkout: number transfer: ${customerStatus}: ${active} terms and conditions`,
      });
    }
  }, [checkboxes]);

  const value = useSelector(
    ({ checkoutDetails }) => checkoutDetails.numberToTransfer
  );

  const maskNumber = () => [value.slice(0, 3), "****", value.slice(-3)].join("");

  const active = useSelector(
    ({ checkoutDetails }) => checkoutDetails.numberTransferType
  );

  if (active === NumberTransferTypes.NEW_NUMBER) {
    return null;
  }
  
  return (
    <>
      {otpResent && (
        <div
          className={styles["number-transfer-step__snackbar"]}
          onClick={() => setOtpResent(false)}
        >
          <div className={styles["number-transfer-step__snackbar-text"]}>
            {labels.upgrade.lbl_otp_resent_info}
          </div>
          <div className={styles["number-transfer-step__snackbar-close"]}>
            +
          </div>
        </div>
      )}
      {generalError && (
        <GeneralError navigate={navigate} showGeneralError={showGeneralError} />
      )}
      <p className={styles["number-transfer-step__subtitle"]}>
        Please enter your prepaid number below:
      </p>
      <CustomContainer
        className={`${styles["number-transfer-number-main-container"]}`}
      >
        <CustomContainer className={`${formStyles["main-container"]}`}>
          <Form.Row className={`${formStyles["main-row"]}`}>
            <Form.Group
              as={Col}
              sm="12"
              md="12"
              className={formStyles["form-group"]}
            >
              <Form.Label className={formStyles["form-label"]}>
                Cellphone number
              </Form.Label>
              <Form.Control
                type="text"
                maxLength={!africaCountryCode(value) ? "10" : "11"}
                name="cellNumber"
                value={value}
                placeholder="Enter your cellphone number"
                onChange={(event) => {
                  event.persist();
                  onChange(event);
                }}
                isInvalid={error}
                className={error ? formStyles["invalid"] : ""}
              />
              <Form.Control.Feedback
                type="invalid"
                className={formStyles["invalid-feedback"]}
              >
                {error}
              </Form.Control.Feedback>
              {!error && (
                <div className={formStyles["hint-text"]}>
                  <span className={formStyles["text-spacing"]}> This must be a prepaid number </span>
                </div>
              )}
            </Form.Group>
          </Form.Row>
        </CustomContainer>
        <NumberTransferCheckboxes
          checkboxes={checkboxes}
          setCheckBoxes={setCheckBoxes}
        />
        <div className={styles["number-transfer-button-wrapper"]}>
          <button
            className={`${styles["number-transfer-button"]} ${
              buttonDisabled() ? styles["number-transfer-button__disabled"] : ""
            }`}
            onClick={onSubmit}
          >
            Next
          </button>
        </div>
      </CustomContainer>
      <UpgradeComponent
        showModal={showModal}
        toggleModal={() => {
          setOtp(["", "", "", ""]);
          setShowSnackBar({
            visible: false,
          });
          sendAnalitycsLink({
            link_name: `checkout: number transfer: ${customerStatus}: dismiss`,
            link_type: "o",
          });
          setOtpResent(false);
          setShowModal(false);
        }}
        displayData={{
          title: labels.upgrade.lbl_enter_otp_title,
          analyticTitle: `checkout: number transfer: ${customerStatus}: enter otp`,
          description: `${
            labels.upgrade.lbl_enter_otp_desc_prefix
          } ${maskNumber()}.<br/>${
            labels.upgrade.lbl_enter_otp_desc_suffix_v2
          }`,
          otpInput: true,
          invalidOTPTries: 0,
          otpValue: otp, // otp,
          otpHandler: setOtp, // setOtp,
          textButton: labels.upgrade.lbl_btn_resend_otp,
          textButtonHandler: () => {
            setOtp(["", "", "", ""]);
            setOtpResent(true);
            sendAnalitycsLink({
              link_name: `checkout: number transfer: ${customerStatus}: resend otp`,
              link_type: "o",
            });
            sendOtp(value);
          }, // resendOTP,
          primaryButtonText: labels.upgrade.lbl_btn_submit_otp,
          primaryButtonStyle:
            otp.filter((pin) => pin).length == 4 && attempts < 4
              ? "solid red"
              : "solid light gray",
          primaryButtonDisabled:
            otp.filter((pin) => pin).length !== 4 || attempts >= 4,
          onClickHandlerPrimary: () => validateOtp(otp, value), // validateOTP,
        }}
      />
    </>
  );
};

NumberTransferNumber.propTypes = {
  setShowSnackBar: PropTypes.func,
  navigate: PropTypes.func,
  customerStatus: PropTypes.string
};

export default NumberTransferNumber;
